import { AngularEditorConfig } from '@kolkov/angular-editor';

export const EDITOR_QUESTION: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter question here...',
    toolbarHiddenButtons: [[
        'strikeThrough', 'subscript', 'superscript', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'insertUnorderedList', 'insertOrderedList', 'heading', 'fontName'
    ], ['customClasses', 'unlink', 'insertVideo', 'removeFormat', 'insertHorizontalRule']]
};

export const EDITOR_OPTION: AngularEditorConfig = {
    ...EDITOR_QUESTION,
    minHeight: '80px',
    maxHeight: '200px',
    placeholder: 'Enter option text here...',
    toolbarHiddenButtons: [[
        'strikeThrough', 'subscript', 'superscript', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'insertUnorderedList', 'insertOrderedList', 'heading', 'fontName', 'insertImage', 'insertVideo', 'insertHorizontalRule'
    ], ['customClasses', 'unlink', 'removeFormat']]
};

export const EDITOR_INLINE_EDIT: AngularEditorConfig = {
    height: 'auto',
    minHeight: '0',
    width: '100%',
    editable: true,
    spellcheck: true,
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text...'
};

export const EDITOR_READONLY: AngularEditorConfig = {
    height: 'auto',
    minHeight: '0',
    width: 'auto',
    editable: false,
    spellcheck: true,
    showToolbar: false
};
